import { Theme } from "@mui/material";
import type { CSSSelectorObject } from "@mui/system";

export type StylesTheme = Theme; // use custom from StriimTheme (can't import for now as it used MUIv4)

export type Styles = CSSSelectorObject<StylesTheme>;

export const FilterBoolean = <T>(p: T): p is Exclude<T, false | null | undefined | 0 | ""> => Boolean(p);
